import { render } from "./UsageViewDetails.vue?vue&type=template&id=aef0d072"
import script from "./UsageViewDetails.vue?vue&type=script&lang=js"
export * from "./UsageViewDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__